module.exports = __webpack_public_path__ + "img/20200512_161701.6ec88503.jpg";